import { render } from "./HomeWorkDetailPage.vue?vue&type=template&id=ed904952&scoped=true"
import script from "./HomeWorkDetailPage.vue?vue&type=script&lang=js"
export * from "./HomeWorkDetailPage.vue?vue&type=script&lang=js"

import "./HomeWorkDetailPage.vue?vue&type=style&index=0&id=ed904952&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed904952"]])

export default __exports__